import { styled } from '@mui/system'

const LoadingWrapperStyled = styled('div')`
	align-items: center;
	background-color: ${({ theme }) => theme.palette.action.loading};
	display: flex;
	height: 100%;
	justify-content: center;
	left: 0;
	position: absolute;
	top: 0;
	width: 100%;
	z-index: 1;
`

export { LoadingWrapperStyled }
